var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.objektListe && _vm.objektListe.length > 0)?_c('span',{staticClass:"objektliste"},[_c('ul',{staticStyle:{"margin":"0","padding":"0"}},_vm._l((_vm.objektListe),function(objekt){return _c('li',{key:objekt.id},[_vm._v(_vm._s(objekt.bezeichnung))])}),0)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }